import { render, staticRenderFns } from "./buyGuide.vue?vue&type=template&id=57b84776&scoped=true&"
import script from "./buyGuide.vue?vue&type=script&lang=js&"
export * from "./buyGuide.vue?vue&type=script&lang=js&"
import style0 from "./buyGuide.vue?vue&type=style&index=0&id=57b84776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b84776",
  null
  
)

export default component.exports